export default "/_next/static/images/b53e809291ad904f9ae198b413f73d7b.jpg";